function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightBlack = function SvgArrowRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.061,
    height: 8.707
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m31.349 2900.283 4 4-4 4",
    transform: "translate(-30.995 -2899.93)",
    style: {
      fill: "none",
      stroke: "#05141f"
    }
  }));
};
export { SvgArrowRightBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1LjA2MSIgaGVpZ2h0PSI4LjcwNyI+CiAgICA8cGF0aCBkPSJtMzEuMzQ5IDI5MDAuMjgzIDQgNC00IDQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMC45OTUgLTI4OTkuOTMpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMDUxNDFmIi8+Cjwvc3ZnPgo=";